import React from 'react';
import './Card.css';

const Card = ({ children, title, className = '' }) => {
  return (
    <div className={`custom-card ${className}`}>
      {title && (
        <div className="custom-card-header">
          <h3>{title}</h3>
        </div>
      )}
      <div className="custom-card-body">{children}</div>
    </div>
  );
};

export default Card;
